var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.seriesData)?_c('div',{staticClass:"timeline-chart"},[_c('apexchart',{attrs:{"type":"rangeBar","height":_vm.setChartHeight(),"options":_vm.chartOptions,"series":_vm.seriesData}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }